import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const self = this

    navigator.clipboard.writeText(this.sourceTarget.innerHTML)

    this.buttonTarget.classList.add("fa-beat")

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(function() {
      self.buttonTarget.classList.remove("fa-beat")
    }, 500)
  }
}
